<div class="progressBar">
  <div class="total"></div>
  <div class="progressLine" [ngStyle]="{'width.%': progress}"></div>
</div>
